export const environment = {
  name: 'production',
  production: true,
  hmr: false,
  apiUrl2: 'https://api.mediego.com',
  websocketUrl: 'wss://api.mediego.com'
};
